import React from 'react'
import { Radio, useMantineTheme } from '@mantine/core'
import { CardSelect } from './CardSelect'

type RadioCardProps = {
  label?: string
  checked?: boolean
  onClick?: () => void
  shadow?: string
  w?: string | number
  h?: string | number
  description?: string
}

export const RadioCard = (props: RadioCardProps) => {
  const {
    label = '',
    checked = false,
    onClick = () => undefined,
    w = '50%',
    h = '100%',
    description
  } = props
  const theme = useMantineTheme()
  return (
    <CardSelect isEnabled={checked} p='lg' style={{ cursor: 'pointer', borderRadius: 8, height: h, width: w, justifyContent: 'center' }} onClick={onClick}>
      <Radio
        checked={checked}
        size='lg'
        label={label}
        fw={500}
        description={description}
        style={{ cursor: 'pointer' }}
        styles={{
          inner: {
            transform: 'scale(1.5)'
          },
          icon: {
            color: theme.colors.newBlue[7]
          },
          radio: {
            backgroundColor: '#d5e0ea',
            border: 'none'
          },
          label: { marginBottom: 0 },
          labelWrapper: { marginLeft: 17 },
          description: { lineHeight: 1.5 }
          }
        } />
    </CardSelect>
  )
}
